import { useEffect, useState } from 'react';
import moment from 'moment/moment';

import { Box, Button, Grid, IconButton, Popover, Stack, Typography } from '@mui/material';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
//API
import { getCalendarPlanCount } from '../../../api/productSamplingWorkflowApi';
import { toast } from 'react-toastify';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default function MonthYearPicker({ filterForm, setFilterForm }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [displayYear, setDisplayYear] = useState(selectedDate.year());
  const [planCounts, setPlanCounts] = useState([]);

  const handleSelectMonth = (monthIndex) => {
    setSelectedDate(moment().year(displayYear).month(monthIndex).date(1));
    setFilterForm({
      ...filterForm,
      month_year: moment().year(displayYear).month(monthIndex).format('YYYY-MM'),
    });
    setAnchorEl(null);
  };

  const loadCalendarPlanCount = async () => {
    try {
      const request = {
        year: moment(filterForm.month_year).format('YYYY'),
      };

      const response = await getCalendarPlanCount(request);
      const { code, data } = response.data;

      if (code === '200') {
        setPlanCounts(data);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    loadCalendarPlanCount();
  }, [filterForm.month_year]);
  return (
    <>
      {/* Trigger */}

      <Stack
        direction='row'
        alignItems='center'
        spacing={1}
        sx={{
          border: '1px solid #D9D9D9',
          borderRadius: 1,
          px: 1.5,
          py: 1,
          bgcolor: '#fff',
          cursor: 'pointer',
          width: 'fit-content',
        }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <CalendarMonthIcon color='success' fontSize='small' />

        <Typography fontWeight={600}>{selectedDate.format('MMM YYYY')}</Typography>

        <KeyboardArrowDownIcon />
      </Stack>

      {/* Popover */}

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        PaperProps={{
          sx: {
            width: 360,
            p: 2,
            mt: 1,
            borderRadius: 1,
          },
        }}
      >
        {/* Header */}

        <Stack direction='row' justifyContent='center' alignItems='center' mb={3}>
          <Typography fontWeight={700} fontSize={24}>
            {displayYear}
          </Typography>
        </Stack>

        {/* Month Grid */}

        <Grid container spacing={1}>
          {MONTHS.map((month, index) => {
            const selected = selectedDate.month() === index && selectedDate.year() === displayYear;

            return (
              <Grid item xs={3} key={month}>
                <Box
                  onClick={() => handleSelectMonth(index)}
                  sx={{
                    height: 58,
                    borderRadius: 1,
                    border: selected ? 'none' : '1px solid transparent',
                    bgcolor: selected ? '#2E7D32' : 'transparent',
                    color: selected ? '#fff' : 'text.primary',
                    cursor: 'pointer',

                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',

                    '&:hover': {
                      borderColor: '#2E7D32',
                    },
                  }}
                >
                  <Typography fontWeight={selected ? 700 : 500}>{month}</Typography>

                  {planCounts[index] > 0 ? (
                    <Typography
                      sx={{
                        fontSize: 11,
                        mt: 0.25,
                      }}
                    >
                      {planCounts[index]} plans
                    </Typography>
                  ) : (
                    ''
                  )}
                </Box>
              </Grid>
            );
          })}
        </Grid>

        {/* Footer */}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 4,
          }}
        >
          <Button
            variant='text'
            color='success'
            onClick={() => {
              const today = moment();

              setSelectedDate(today);
              setDisplayYear(today.year());
              setAnchorEl(null);
            }}
          >
            TODAY
          </Button>
        </Box>
      </Popover>
    </>
  );
}
